export const actionButtons = [
  {
    label: 'Сотрудник',
    icon: 'add',
    id: 'step-5',
    action: {
      name: 'EmployeeAddModal',
      type: 'modal' as const,
    },
  },
  {
    label: 'Факторы',
    icon: 'notification_important',
    id: 'step-6',
    action: {
      name: 'HazardsModal',
      type: 'modal' as const,
    },
  },
  {
    label: 'QR',
    icon: 'qr_code_scanner',
    id: 'step-6',
    action: {
      name: 'ReferralLinkModal',
      type: 'modal' as const,
    },
  },
] as const;
